__webpack_require__.p = "https://frontends.udemycdn.com/frontends-cart/_next/";